import { ReactNode, createElement } from 'react';
import classnames from 'classnames';

type Tag = 'article' | 'section' | 'div';

interface Props {
  border?: boolean;
  center?: boolean;
  children: ReactNode;
  display?: string;
  gap?: 'small' | 'normal';
  maxHeight?: boolean;
  shadow?: boolean;
  tag?: Tag;
}

const Card = ({
  border = false,
  center = false,
  children,
  display = 'flex',
  gap = undefined,
  maxHeight = false,
  shadow = false,
  tag = 'div',
}: Props) => {
  const className = classnames({
    'bg-card-background-color': true,
    rounded: true,
    'text-card-text-color': true,
    relative: true,
    'w-full': true,
    'break-inside-avoid': true,
    flex: display === 'flex',
    'flex-1': display === 'flex',
    'flex-col': display === 'flex',
    'inline-block': display === 'inlineBlock',
    'h-full': maxHeight,
    border: border,
    'border-card-border-color': border,
    'drop-shadow-sm': shadow,
    'justify-center': center,
    'mb-2': gap === 'small',
    'mb-3': gap === 'normal',
    'only:!mb-0': display === 'flex' && gap,
    'last:!mb-0': display === 'flex' && gap,
  });

  return createElement(tag, { className }, children);
};

export default Card;
